/**
 * Part del l'API del RefCadAdrWidget
 * Component: RefCadAdrWidgetAPI.ts
 * Llenguatge: TypeScript
 * Autors: Xavier Naval
 * Versió: 1.0
 * Data: 29/09/2017
 * (c) Ajuntament de Manresa - set 2017 - Departament de Sistemes d'Informació
 */
 import AjtAjaxAxios from 'ajt-ajax';
 import { IFinca, IRefCad, IFinCod, INumero } from '../interfaces/IRefCadAdr';
 
 export default class RefCadAdrWidgetAPI {
     // Constructor
     constructor(urlAPI?: string) {
         if (urlAPI) {
             this.urlBase = urlAPI;
         }
     }
 
     // Request
     private req: AjtAjaxAxios = new AjtAjaxAxios();
 
     // Base de dades per defecte
     bd = 'AJT';
 
     // URL base on hi ha l'api per els RefCadAdrWidget
     urlBase = 'http://intranetserver/intranet/public/NucliPublic/1.0/api';
     // urlBase = 'http://localhost:64366/api';
 
     // URL completa on hi ha l'api per els RefCadAdrWidget
     get url(): string {
         return `${this.urlBase}/${this.bd}/`;
     }
 
     // Dona accés el Request d'aquesta api
     get request(): AjtAjaxAxios {
         return this.req;
     }
 
     // Retorna un Promise amb la finca del FinCod demanat
     // pFinCod: FinCod a buscar
     getFincaPerFinCod(pFinCod: number): Promise<IFinca> {
         return this.req.getRequest(this.url + 'FIS_FINCA/PerFinCod', { id: pFinCod }) as Promise<IFinca>;
     }
 
     // Retorna un Promise amb la referència cadastral del FinCod demanat
     // pFinCod: FinCod a buscar
     getRefCad(pFinCod: number): Promise<IRefCad> {
         return this.req.getRequest(this.url + 'FIS_FINCA/GetRefCad', { id: pFinCod }) as Promise<IRefCad>;
     }
 
     // Retorna un Promise amb el FinCod de la referència cadatral demanada
     // pRefCad: Referència cadastral a buscar (pot ser de 7 o de 14)
     getFinCod(pRefCad: string): Promise<IFinCod> {
         return this.req.getRequest(this.url + 'FIS_FINCA/GetFinCod', { id: pRefCad }) as Promise<IFinCod>;
     }
 
     // Retorna un Promise amb un array amb les finques que la referència cadastral coincideix amb el paràmetre pRefCad
     // pRefCad: part de la referència cadastral
     // pSkip: número de registres a saltar
     // pPageSize: Número de registres a retornar
     getFinquesPerRefCad(pRefCad: string, pSkip: number, pPageSize: number): Promise<Array<IFinca>> {
         return this.req.getSequentialRequest(this.url + 'FIS_FINCA/PerRefCad', { id: pRefCad, skip: pSkip, pageSize: pPageSize }) as Promise<Array<IFinca>>;
     }
 
    // Retorna un Promise amb un array amb les finques que el polígon parcel·la coincideix amb el paràmetre pPolPar
    // pPolPar: polígon parcel·la (separats per un espai p ex "18 100")
    // pSkip: número de registres a saltar
    // pPageSize: Número de registres a retornar
    getFinquesPerPolPar(pPolPar: string, pSkip: number, pPageSize: number): Promise<Array<IFinca>> {
        return this.req.getSequentialRequest(this.url + 'FIS_FINCA/PerPolPar', { id: pPolPar, skip: pSkip, pageSize: pPageSize }) as Promise<Array<IFinca>>;
    }

     // Retorna un Promise amb un array amb les finques que l'adreça' coincideix amb el paràmetre pAdreca
     // pAdreca: Part del nom de carrer a buscar (no s'ha de posar ni el tipus de via, ni l'article. El número sí que es pot posar)
     // pSkip: número de registres a saltar
     // pPageSize: Número de registres a retornar
     getFinquesPerAdreca(pAdreca: string, pSkip: number, pPageSize: number): Promise<Array<IFinca>> {
         return this.req.getSequentialRequest(this.url + 'FIS_FINCA/PerAdreca', { id: pAdreca, skip: pSkip, pageSize: pPageSize }) as Promise<Array<IFinca>>;
     }
 
     // Retorna un Promise amb un array amb les finques que l'adreça' coincideix amb el paràmetre pAdreca
     // pLike: Part de la referència, del nom de carrer o el codi a buscar (no s'ha de posar ni el tipus de via, ni l'article. El número sí que es pot posar)
     // pSkip: número de registres a saltar
     // pPageSize: Número de registres a retornar
     getFinquesPerLike(pLike: string, pSkip: number, pPageSize: number): Promise<Array<IFinca>> {
         return this.req.getSequentialRequest(this.url + 'FIS_FINCA/PerLike', { pLike: pLike, skip: pSkip, pageSize: pPageSize }) as Promise<Array<IFinca>>;
     }
 
     // Retorna un Promise amb un array amb els números que l'adreça' coincideix amb el paràmetre pAdreca
     // Cridem a la funció MGPerAdreca per que només retorni els números dels que tenim coordenades
     // pAdreca: Part del nom de carrer a buscar (no s'ha de posar ni el tipus de via, ni l'article. El número sí que es pot posar)
     // pSkip: número de registres a saltar
     // pPageSize: Número de registres a retornar
     getNumerosPerAdreca(pAdreca: string, pSkip: number, pPageSize: number): Promise<Array<INumero>> {
         return this.req.getSequentialRequest(this.url + 'NCL_NUMERO/MGPerAdreca', { id: pAdreca, skip: pSkip, pageSize: pPageSize }) as Promise<Array<INumero>>;
     }
 
     // Retorna un Promise amb el número del NumCod demanat
     // pNumCod: NumCod a buscar
     getNumeroPerNumCod(pNumCod: number): Promise<INumero> {
         return this.req.getRequest(this.url + 'NCL_NUMERO/M2PerNumCod', { id: pNumCod }) as Promise<INumero>;
     }
 
 }